<template>
  <div>
    <label class="grey--text text--darken-4 text-body-2 font-weight-medium">
      {{ title }}
    </label>

    <div
      @click="$refs.fileInput.click()"
      @dragleave.prevent="onDragLeave"
      @dragover.prevent="onDragOver"
      @drop.prevent="onDrop"
      class="mt-1 upload-area"
      :class="{ 'is-dragover': isDragging }"
    >
      <v-icon size="64" color="primary">mdi-cloud-upload</v-icon>
      <div class="text-h6 mt-2">
        Arraste arquivos aqui ou
        <span class="primary--text">clique para selecionar</span>
      </div>

      <div
        v-if="filesTypesText"
        class="text-caption grey--text text--darken-1 mb-2"
      >
        {{ filesTypesText }}
      </div>

      <input
        type="file"
        ref="fileInput"
        :accept="accept"
        class="d-none"
        @change="handleFiles"
      />
    </div>

    <div
      v-if="helper"
      class="grey--text text-caption font-weight-regular ml-2 mt-1"
    >
      {{ helper }}
    </div>

    <template v-if="file">
      <v-list class="mt-2">
        <v-list-item class="list-item-file">
          <v-list-item-icon>
            <v-icon>mdi-file-document-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ file.name }}</v-list-item-title>
            <v-list-item-subtitle>
              {{ (file.size / 1024).toFixed(2) }} KB
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn @click.stop="removeFile(index)" icon>
              <v-icon color="red">mdi-delete-outline</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    accept: {
      type: String,
      default: "*",
    },
    helper: {
      type: String,
      default: "",
    },
    value: {
      type: File,
      default: null,
    },
  },
  data: () => ({
    isDragging: false,
    file: null,
  }),
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.file = val;
      },
    },
  },
  computed: {
    filesTypesText() {
      if (this.accept === "*") return "Suporta todos os formatos";

      const exts = this.accept
        .split(",")
        .map((ext) => ext.trim().replace(".", "").toUpperCase());

      if (exts.length === 1) {
        return `Suporta arquivo ${exts[0]}`;
      }

      const last = exts.pop();

      return `Suporta arquivo ${exts.join(", ")} e ${last}`;
    },
  },
  methods: {
    onDragOver() {
      this.isDragging = true;
    },
    onDragLeave() {
      this.isDragging = false;
    },
    onDrop(e) {
      this.isDragging = false;

      if (e.dataTransfer.files.length) {
        this.validateAndSetFile(e.dataTransfer.files[0]);
      }
    },
    handleFiles(e) {
      if (e.target.files.length) {
        this.validateAndSetFile(e.target.files[0]);
      }

      e.target.value = "";
    },
    validateAndSetFile(file) {
      const allowedExtensions = this.accept
        .split(",")
        .map((ext) => ext.trim().toLowerCase());

      const fileName = file.name.toLowerCase();

      const isValid = allowedExtensions.some((ext) => {
        if (ext === "*") return true;

        return fileName.endsWith(ext);
      });

      if (!isValid) {
        this.$eventHub.$emit("snackBar", {
          icon: "mdi-file-alert",
          message: "Arquivo não suportado. Verifique e tente novamente.",
          type: "alert",
        });

        return;
      }

      this.file = file;
      this.$emit("input", file);
    },
    removeFile() {
      this.file = null;
      this.$emit("input", null);
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-area {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 18px;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;
  background-color: #fafafa;

  &:hover,
  &.is-dragover {
    border-color: #1976d2;
    background-color: #e3f2fd;
  }
}

.d-none {
  display: none;
}

.list-item-file {
  background-color: transparent;
  border-radius: 8px;
  transition: all 0.1s linear;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
}
</style>
